import { render } from "./ThePathHeader.vue?vue&type=template&id=03c13ebd&scoped=true"
import script from "./ThePathHeader.vue?vue&type=script&lang=js"
export * from "./ThePathHeader.vue?vue&type=script&lang=js"

import "./ThePathHeader.vue?vue&type=style&index=0&id=03c13ebd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03c13ebd"]])

export default __exports__